import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VError = _resolveComponent("VError")!

  return (_openBlock(), _createBlock(_component_VError, {
    name: _ctx.$attrs.name,
    as: "small",
    class: "p-error"
  }, {
    default: _withCtx(({message}) => [
      _createTextVNode(_toDisplayString(_ctx.$t(message)), 1)
    ]),
    _: 1
  }, 8, ["name"]))
}